import React, { Component } from "react";
import adminService from "../../Services/adminService";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MaterialTableComponent from "../../NestedComponents/widgets/materialTable";
import { toast } from "react-toastify";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import DisplayMembersSummary from "./displayMembersSummary";
import "../../assets/css/popups.css";
import Swal from "sweetalert2";
import moment from "moment";
import {
  USER_SEARCH_BY_TYPE_STATE_FIELDS,
  MEMBER_ACTIVITY_STATES,
  EXCEL_DOWNLOAD_STATE_FIELDS,
  MEMBER_VALIDITY_STATES,
  VALID_EXCEL_TYPES
} from "../../global/userConstants";

// TODO: Remove HIGHLIGHTED_STATUSES, highlightStyle, renderStatusCell, and statusEditComponent
// once Lyn finishes migrating all clients to the new statuses. These are temporary helpers
// to visually distinguish the new status options (blue) from old ones during the transition.
const HIGHLIGHTED_STATUSES = [
  "irrelevant", "exClient", "exClientNotInterested", "exClientInProgress",
  "potential", "potentialNotInterested", "potentialInProgress", "sold"
];

const highlightStyle = { color: "#1976d2", fontWeight: "bold" };

const renderStatusCell = (lookup) => (rowData, field) => {
  const code = rowData[field];
  const label = lookup[code] || code || "";
  const isHighlighted = HIGHLIGHTED_STATUSES.includes(code);
  return <span style={isHighlighted ? highlightStyle : {}}>{label}</span>;
};

const statusEditComponent = (lookup) => (props) => (
  <Select
    value={props.value || ""}
    onChange={(e) => props.onChange(e.target.value)}
    style={{ width: "100%" }}
  >
    {Object.entries(lookup).map(([code, label]) => (
      <MenuItem key={code} value={code} style={HIGHLIGHTED_STATUSES.includes(code) ? highlightStyle : {}}>
        {label}
      </MenuItem>
    ))}
  </Select>
);

const btaxCol = { title: "ביטקס סטטוס", field: "btaxStatus", lookup: {} };
// const bquickCol = { title: "Bquick סטטוס", field: "bquickStatus", lookup: {} };
const activityStates = MEMBER_ACTIVITY_STATES;
const searchByTypeStateFields = USER_SEARCH_BY_TYPE_STATE_FIELDS;
const excelDownloadStateFields = EXCEL_DOWNLOAD_STATE_FIELDS;
class AdminUsersManager extends Component {
  state = {
    role: "",
    searchKey: "",
    isFilterSearch: false,
    searchTypes: null,
    productStates: [],
    searchCompany: "btax",
    reloadingTable: false,
    isSalesmenListOpen: false,
    isCompaniesTypesOpen: false,
    selectedSalesMan: null,
    usersList: [],
    salesAccs: [],
    searchClientNotBelongToAnybody: false,
    searchClientBelongToSpecific: false,
    clientJobTitle: "",
    amountOfUsersToReturn: 30,
    clientOwner: "",
    searchActivityStatuses: "",
    searchValidityStatuses: "",
    excelType: "",
    membershipExpiryStartDate: "",
    membershipExpiryEndDate: "",
    columns: [
      btaxCol,
      // bquickCol,
      { title: "שם משרד", field: "officeName", editable: "onEdit" },
      { title: "שם מלא", field: "fullName", editable: "onAdd" },
      { title: "טלפון", field: "mobile", editable: "onAdd" },
      { title: "אימייל", field: "email", editable: "onAdd" },
      { title: "משתמשים פעילים", field: "activeMembers", editable: "never" },
      { title: "סטטוס משתמש", field: "activityStatus", editable: "never" }, //column header is for the user's members
      { title: "מספר כרטיס", field: "cardNum" }
    ],
    isPopupOpen: false,
    focusedUser: null,
    showSearchNotFoundMsg: false
  };

  componentDidMount() {
    adminService.getSalesAccountsList().then((res) => {
      if (res["success"]) {
        var newState = { salesAccs: res["salesAccs"] };
        if (this.props.match.params.givenSearchKey) {
          newState["searchKey"] = this.props.match.params.givenSearchKey;
        }
        this.setState(newState, () => {
          if (this.props.match.params.givenSearchKey) {
            this.handleSubmitSearch();
          }
        });
      }
    });

    this.setState({ role: localStorage.getItem("role") });
    toast.dismiss();

    // get user statuses/states for btax product (- for btax and bquick) - for loockup
    adminService.getClientProductStatuses(["btax"]).then((productStatuses) => {
      //make lookup obj
      const lookup =
        productStatuses?.["btax"]?.reduce((acc, curr) => {
          return { ...acc, [curr.stateName]: curr.stateHeb };
        }, {}) || {};

      const statusRender = renderStatusCell(lookup);
      const editComp = statusEditComponent(lookup);
      this.setState({
        columns: [
          ...this.state.columns.map((col) => {
            if (col.field === btaxCol.field)
              return { ...btaxCol, lookup, render: (rowData) => statusRender(rowData, "btaxStatus"), editComponent: editComp };
            // if (col.field === bquickCol.field)
            //   return { ...bquickCol, lookup, render: (rowData) => statusRender(rowData, "bquickStatus"), editComponent: editComp };
            return col;
          })
        ]
      });
    });

    adminService.getAllProductStates().then((res) => {
      this.setState({ productStates: res });
    });
  }

  render() {
    return (
      <div className="container pb-70">
        <DisplayMembersSummary />

        <h2 className="yellow-color">ניהול משתמשים</h2>
        <div className="row">
          <div className="col-sm-12 mb-20">
            <TextField
              required
              label="ניתן לחפש משתמשים לפי משרד, מייל, שם או מספר טלפון"
              className="field-strech"
              id="searchKey"
              value={this.state.searchKey}
              onChange={this.handleSearchKeyChanged}
              onKeyPress={(e) => {
                this.handleKeyPress(e.key, this.handleSubmitSearch);
              }}
            />
            <div className="mt-20">
              <Button onClick={this.handleSubmitSearch} color="primary" variant="contained" size="small">
                חפש
              </Button>
            </div>
          </div>

          <ExpansionPanel
            className="mr-20"
            style={{ width: "96.9%" }}
            expanded={this.state.isFilterSearch}
            onChange={() => {
              this.setState({ isFilterSearch: !this.state.isFilterSearch });
            }}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className="questions-page-wrapper">
              <h5 className="mb-0">חיפוש מתקדם</h5>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div className="row">
                <div className="col-sm-12">
                  <div className="mt-20 mb-10 fs-17 primary-color">
                    <b>פילטרים למשרדים</b>
                  </div>
                  <div className="">
                    <div className="mr-20 active-color">
                      <b>חברה</b>
                    </div>

                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={<Checkbox value="btax" color="primary" checked={this.state.searchCompany && this.state.searchCompany.includes("btax")} />}
                      label="BTax"
                      onChange={(e) => {
                        this.searchTypeChanged(e, "btax", true);
                      }}
                    />
                    {/* <FormControlLabel
                      className="align-checkbox-opts"
                      control={<Checkbox value="bquick" color="primary" />}
                      label="Bquick"
                      onChange={(e) => {
                        this.searchTypeChanged(e, "bquick", true);
                      }}
                    />
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={<Checkbox value="silver" color="primary" />}
                      label="סילבר"
                      onChange={(e) => {
                        this.searchTypeChanged(e, "silver", true);
                      }}
                    />
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={<Checkbox value="gold" color="primary" />}
                      label="גולד"
                      onChange={(e) => {
                        this.searchTypeChanged(e, "gold", true);
                      }}
                    />
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={<Checkbox value="platinum" color="primary" />}
                      label="פלטינום"
                      onChange={(e) => {
                        this.searchTypeChanged(e, "platinum", true);
                      }}
                    /> */}
                  </div>
                  <div>
                    <div className="mr-20 active-color">
                      <b>סטטוס</b>
                    </div>
                    {this.state.productStates &&
                      this.state.productStates.map((state) => {
                        return (
                          <FormControlLabel
                            className="align-checkbox-opts"
                            control={<Checkbox value={state.stateName} color="primary" />}
                            label={state.stateHeb}
                            onChange={(e) => {
                              this.searchTypeChanged(e, state.stateName);
                            }}
                          />
                        );
                      })}
                    <div className="mr-20 active-color">
                      <b>הצג תוצאות מוקצות</b>
                    </div>
                    <div className="inline-block mr-20 ml-20">סוג לקוח</div>
                    <FormControl>
                      <Select
                        value={this.state.clientJobTitle}
                        onChange={(e) => {
                          this.handleChange(e, "clientJobTitle");
                        }}
                        displayEmpty
                      >
                        <MenuItem value=""></MenuItem>
                        {adminService.getClientJobOptions().map((item) => {
                          return (
                            <MenuItem key={item.key} value={item.key}>
                              {item.label}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={<Checkbox color="primary" />}
                      label="לא שייך לאף אחד"
                      onChange={(e) => {
                        this.handleChange({ target: { value: e.target.checked } }, "searchClientNotBelongToAnybody");
                      }}
                      disabled={this.state.searchClientBelongToSpecific}
                    />
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={<Checkbox color="primary" />}
                      label="שייך לאיש מכירות"
                      onChange={(e) => {
                        this.handleChange({ target: { value: e.target.checked } }, "searchClientBelongToSpecific");
                      }}
                      disabled={this.state.searchClientNotBelongToAnybody}
                    />
                    <div className="mt-minus-20 inline-block">
                      {this.state.searchClientBelongToSpecific ? (
                        <FormControl className="list-sales-accs">
                          <InputLabel className="align-select-label">רשימת אנשי מכירות</InputLabel>
                          <Select
                            className="select-field"
                            value={this.state.clientOwner}
                            onChange={(e) => {
                              this.handleChange(e, "clientOwner");
                            }}
                            displayEmpty
                          >
                            {this.state.salesAccs.map((item) => {
                              return (
                                <MenuItem key={item.email} value={item.email}>
                                  {item.firstName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      ) : null}
                    </div>
                    <div className="mr-20 active-color">
                      <b>כמות משתמשים להחזרה</b>
                    </div>
                    <div className="mr-20">
                      <TextField
                        onChange={(e) => {
                          this.handleChange(e, "amountOfUsersToReturn");
                        }}
                        type="number"
                        value={this.state.amountOfUsersToReturn}
                      />
                    </div>
                    <div className="mt-20 mb-10 fs-17 primary-color">
                      <b>פילטרים ליוזרים</b>
                    </div>
                    <div className="mr-20 active-color">
                      <b>סטטוס פעילות</b>
                    </div>
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={
                        <Checkbox
                          value={this.state.searchActivityStatuses?.split(":")?.includes(MEMBER_ACTIVITY_STATES.active.field)}
                          color="primary"
                        />
                      }
                      label="פעיל"
                      onChange={(e) => {
                        this.handleMembersSearchFiltersChange(
                          e.target.checked,
                          "searchActivityStatuses",
                          MEMBER_ACTIVITY_STATES.active.field
                        );
                      }}
                    />
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={
                        <Checkbox
                          value={this.state.searchActivityStatuses?.split(":")?.includes(MEMBER_ACTIVITY_STATES.suspended.field)}
                          color="primary"
                        />
                      }
                      label="מושהה"
                      onChange={(e) => {
                        this.handleMembersSearchFiltersChange(
                          e.target.checked,
                          "searchActivityStatuses",
                          MEMBER_ACTIVITY_STATES.suspended.field
                        );
                      }}
                    />
                    <div className="mr-20 active-color">
                      <b>סטטוס תוקף</b>
                    </div>
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={
                        <Checkbox
                          value={this.state.searchValidityStatuses?.split(":")?.includes(MEMBER_VALIDITY_STATES.valid)}
                          color="primary"
                        />
                      }
                      label="תקף"
                      onChange={(e) => {
                        this.handleMembersSearchFiltersChange(e.target.checked, "searchValidityStatuses", MEMBER_VALIDITY_STATES.valid);
                      }}
                    />
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={
                        <Checkbox
                          value={this.state.searchValidityStatuses?.split(":")?.includes(MEMBER_VALIDITY_STATES.expired)}
                          color="primary"
                        />
                      }
                      label="פג תוקף"
                      onChange={(e) => {
                        this.handleMembersSearchFiltersChange(e.target.checked, "searchValidityStatuses", MEMBER_VALIDITY_STATES.expired);
                      }}
                    />
                    {!this.state.searchValidityStatuses.split(":")?.includes("valid") && (
                      <div className="mr-20">
                        <p className="fs-14">(תקף - מאפשר בחירת תאריכי תחילה וסיום לסיומי מנוי)</p>
                      </div>
                    )}
                    {this.state.searchValidityStatuses.split(":")?.includes("valid") && (
                      <>
                        <div className="mr-20 active-color">
                          <b>משתמשים שהמנוי שלהם נגמר בין התאריכים</b>
                        </div>

                        <div className="mr-20 inline-block">
                          <div>תאריך התחלה</div>
                          <input
                            id="startDate"
                            value={this.state.membershipExpiryStartDate}
                            className="date-field padding13"
                            min={moment().format("YYYY-MM-DD")}
                            type="date"
                            onChange={({ target: { value: startDate } }) => {
                              const { membershipExpiryEndDate: stateEndDate } = this.state;
                              //if choose a new start date after current end date - reset end date
                              this.setState({
                                membershipExpiryStartDate: startDate,
                                membershipExpiryEndDate: stateEndDate && startDate > stateEndDate ? "" : stateEndDate
                              });
                            }}
                          />
                        </div>
                        <div className="mr-20 inline-block">
                          <div>תאריך סיום</div>
                          <input
                            id="endDate"
                            className="date-field padding13"
                            min={
                              this.state.membershipExpiryStartDate ? this.state.membershipExpiryStartDate : moment().format("YYYY-MM-DD")
                            }
                            type="date"
                            value={this.state.membershipExpiryEndDate}
                            onChange={({ target: { value: endDate } }) => {
                              this.setState({
                                membershipExpiryEndDate: endDate
                              });
                            }}
                          />
                        </div>
                      </>
                    )}
                    <div className="mt-20 mb-10 fs-17 primary-color">
                      <b>פילטרים לייצוא קובץ אקסל</b>
                    </div>
                    <div className="mr-20 active-color">
                      <b>סוג אקסל</b>
                    </div>
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={<Checkbox checked={this.state.excelType === VALID_EXCEL_TYPES.fullExcel ? true : false} color="primary" />}
                      label="אקסל מורחב"
                      onChange={(e) => {
                        this.setState({ excelType: VALID_EXCEL_TYPES.fullExcel });
                      }}
                    />
                    <FormControlLabel
                      className="align-checkbox-opts"
                      control={<Checkbox checked={this.state.excelType === VALID_EXCEL_TYPES.smooveExcel ? true : false} color="primary" />}
                      label="אקסל Smoove "
                      onChange={(e) => {
                        this.setState({ excelType: VALID_EXCEL_TYPES.smooveExcel });
                      }}
                    />

                    <br />
                    <br />
                    <Button onClick={this.handleSearchByTypes} color="primary" variant="contained" size="small">
                      חפש לפי קטגוריות
                    </Button>
                    <Button
                      onClick={this.handleDownloadUserMailsExcelFile}
                      color="primary"
                      variant="contained"
                      size="small"
                      className="mr-4"
                    >
                      ייצא לקובץ Excel
                    </Button>
                  </div>
                </div>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
        <div className="row mt-50">
          <div className="user-table-con col-sm-12">
            {this.state.showSearchNotFoundMsg ? (
              <h4 className="primary-color mb-20">
                לא ניתן היה למצוא משתמשים לפי מילת החיפוש שהוזנה:
                <br />
                (Key: {this.state.searchKey})
              </h4>
            ) : null}
            {this.state.reloadingTable ? (
              <h4 className="primary-color">טוען מידע...</h4>
            ) : (
              <div className="relative">
                {this.state.usersList && this.state.usersList[0] && this.isRoleAllowed() ? (
                  <div className="add-users-to-salesman-container">
                    <i onClick={this.toggleSalesmenList} className="material-icons">
                      attach_file
                    </i>
                    {this.state.isSalesmenListOpen ? (
                      <div className="list-of-salesmen">
                        {this.state.salesAccs.map((item, i) => {
                          return (
                            <div
                              key={i + "sales"}
                              className="center pt-10"
                              onClick={() => {
                                this.openCompaniesType(item);
                              }}
                            >
                              {item.firstName}
                            </div>
                          );
                        })}
                      </div>
                    ) : null}

                    {this.state.isCompaniesTypesOpen ? (
                      <div className="list-of-salesmen">
                        <div
                          className="center pt-10"
                          onClick={() => {
                            this.addClientListToSpecificSalesman("btax");
                          }}
                        >
                          BTax
                        </div>
                        <div
                          className="center pt-10"
                          onClick={() => {
                            this.addClientListToSpecificSalesman("bquick");
                          }}
                        >
                          Bquick
                        </div>
                        <div
                          className="center pt-10"
                          onClick={() => {
                            this.addClientListToSpecificSalesman("courses");
                          }}
                        >
                          קורסים
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                <MaterialTableComponent
                  options={{ pageSizeOptions: [5, 10, 20, 100], debounceInterval: 1000 }}
                  data={this.state.usersList}
                  columns={[...this.state.columns]}
                  parentChildData={(row, rows) => (row.belongToCardNum ? rows.find((a) => a.cardNum === row.belongToCardNum) : undefined)} //to show members under their user
                  onDataChanged={this.handleDataChange}
                  hideRedirectToSpecificUserOnMemberRow={true}
                  redirectToSpecificUser={this.redirectToSpecificUser}
                  enableRedirectMiddleClick
                  tableTitle="טבלת משרדים ומשתמשים"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  handleKeyPress = function (keyClicked, functionToTrigger) {
    if (keyClicked === "Enter") functionToTrigger();
  };

  handleChange = (e, key) => {
    this.setState({ [key]: e.target.value });
  };

  handleMembersSearchFiltersChange = (checked, stateKey, value) => {
    //value is either empty string or a string with the selected options (one or multiple) of the stateKey in checkboxes
    const stateVal = this.state?.[stateKey] === "" ? [] : this.state?.[stateKey]?.trim().split(":");
    if (checked && !stateVal?.includes(value)) {
      this.setState({ [stateKey]: stateVal ? [...stateVal, value].join(":") : value });
    }
    if (!checked && stateVal?.includes(value)) {
      this.setState({ [stateKey]: this.state?.[stateKey] === value ? "" : stateVal.filter((val) => val !== value).join(":") });
    }
  };

  searchTypeChanged = (e, type, isCompany) => {
    var value;
    var optsToModify = isCompany ? this.state.searchCompany : this.state.searchTypes;
    if (e.target.checked) {
      if (optsToModify) value = optsToModify + ":" + type;
      else value = type;
    } else {
      value = optsToModify
        .split(":")
        .filter((item) => item !== type)
        .join(":");
    }
    var stateToUpdate = {};
    if (isCompany) stateToUpdate["searchCompany"] = value;
    else stateToUpdate["searchTypes"] = value;
    this.setState(stateToUpdate);
  };

  isRoleAllowed = () => {
    if (this.state.role === "admin" || this.state.role === "salesManager") return true;
    return false;
  };

  handleSearchByTypes = () => {
    if (!this.state.searchTypes || !this.state.searchCompany) {
      Swal.fire("", "יש להזין לפחות סוג חיפוש אחד", "warning");
      return;
    }

    if (!this.state.amountOfUsersToReturn || this.state.amountOfUsersToReturn > 1000 || this.state.amountOfUsersToReturn < 1) {
      Swal.fire("", "כמות המשתמשים שאתה מחפש אינה חוקית", "warning");
      return;
    }

    if (this.state.searchClientBelongToSpecific && !this.state.clientOwner) {
      Swal.fire("", "יש להזין שם סוכן לחיפוש", "warning");
      return;
    }

    this.setState({ showSearchNotFoundMsg: false, reloadingTable: true });

    const queryObj = searchByTypeStateFields.reduce((obj, field) => {
      return { ...obj, [field]: this.state[field] };
    }, {});

    adminService.searchByType(queryObj).then((res) => {
      if (res["success"]) {
        var dataFromDB = res["usersList"];
        if (!dataFromDB || !dataFromDB[0]) {
          this.setState({ showSearchNotFoundMsg: true, usersList: [] }, () => {
            this.setState({ reloadingTable: false });
          });
          return;
        }

        dataFromDB = dataFromDB.map((item) => {
          item.isEmailConfirmed = item.isEmailConfirmed ? 1 : 0;
          item.activeMembers = item.members.filter((x) => x.status === "active").length;
          item.activityStatus = "";
          return item;
        });

        //adding the members to the data in the material table
        const usersAndMembersList = [...dataFromDB];
        dataFromDB.forEach((user) => {
          user?.members?.forEach((member) =>
            //get default columns for the material table
            usersAndMembersList.push({
              ...this.state.columns.reduce((acc, curr) => {
                return { ...acc, [curr.field]: "" };
              }, {}),
              //add the specific member field
              ...member,
              //activityStatus
              activityStatus: Object.values(activityStates).find((state) => state.field === member.status).title,
              //show cardNum
              cardNum: member.belongToCardNum
            })
          );
        });

        this.setState({ usersList: usersAndMembersList }, () => {
          this.setState({ reloadingTable: false });
        });
      }
    });
  };

  handleDownloadUserMailsExcelFile = (e) => {
    //receive excel data from server
    if (e) e.preventDefault();

    if (!this.state.excelType) {
      Swal.fire("", "יש להזין את סוג מסמך ה-Excel", "warning");
      return;
    }

    const queryObj = excelDownloadStateFields.reduce((obj, field) => {
      return { ...obj, [field]: this.state[field] };
    }, {});
    adminService.generateUsersSearchExcelFile(queryObj).then(({ success }) => {
      if (success) Swal.fire(`הקובץ ירד בהצלחה`, "", "success");
      else Swal.fire(`התרחשה תקלה בהורדת הקובץ`, "", "error");
    });
  };

  toggleSalesmenList = () => {
    var newState = { isCompaniesTypesOpen: false };
    if (this.state.isCompaniesTypesOpen) {
      newState["isSalesmenListOpen"] = false;
      newState["selectedSalesMan"] = null;
    } else {
      newState["isSalesmenListOpen"] = !this.state.isSalesmenListOpen;
    }

    this.setState(newState);
  };

  openCompaniesType = (selectedSalesMan) => {
    this.setState({ isCompaniesTypesOpen: true, isSalesmenListOpen: false, selectedSalesMan });
  };

  addClientListToSpecificSalesman = (companyType) => {
    var salesman = this.state.selectedSalesMan;
    Swal.fire({
      title: salesman.firstName,
      text: "לשייך את כל הרשימה לסוכן?",
      icon: "warning",
      showCancelButton: true
    }).then((result) => {
      if (result.value) {
        var listOfUsersCardNums = [];
        for (const user of this.state.usersList) {
          listOfUsersCardNums.push({ cardNum: user.cardNum });
        }
        adminService.setSalemanOwningUsers(salesman.email, companyType, listOfUsersCardNums).then((res) => {
          if (res["success"]) {
            this.toggleSalesmenList();
            Swal.fire(`בוצע`, "", "success");
          } else {
          }
        });
      }
    });
  };

  handleSearchKeyChanged = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
      showSearchNotFoundMsg: false
    });
  };

  handleDataChange = (dataToModify, action) => {
    return new Promise((resolve, reject) => {
      //currently can not edit members from table - if its a member - has belongToCardNum - prevent edit
      if (dataToModify.belongToCardNum) return reject();
      Swal.fire({
        title: "האם אתה בטוח?",
        text: "אתה הולך לעשות את הפעולה הבאה על המשתמש: " + action,
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          adminService.adminUpdateUserData(dataToModify.cardNum, dataToModify, null, action).then((res) => {
            if (res["success"]) {
              if (res["newId"]) resolve(res["newId"]);
              else resolve();
              Swal.fire(`${action} - בוצע`, "", "success");
            } else {
              if (res["isExistingUser"]) {
                Swal.fire(`${action} - לא בוצע`, "קיים כבר משתמש", "warning");
              }
              reject();
            }
          });
        } else {
          reject();
        }
      });
    });
  };

  redirectToSpecificUser = (userData, e) => {
    let userId = userData._id;
    //if clicked on a member - get the id of the associated user - to get to the card page of the associated user
    if (userData.belongToCardNum) userId = this.state.usersList.find((user) => user.cardNum === userData.belongToCardNum)._id;
    if (e.ctrlKey || e.metaKey || e.button === 1) window.open("/admin/specific-user/" + userId, "_blank");
    else this.props.history.push("/admin/specific-user/" + userId);
  };

  handleSubmitSearch = (e) => {
    if (e) e.preventDefault();

    if (this.state.searchKey.length < 3) {
      if (isNaN(this.state.searchKey)) {
        Swal.fire("", "מינימום שלוש אותיות לחיפוש", "warning");
        return;
      }
    }
    this.setState({ showSearchNotFoundMsg: false, reloadingTable: true }, () => {
      //get users and their members by search key
      adminService.getUsersBySearchKey(this.state.searchKey.trim(), true).then((res) => {
        if (res["success"]) {
          var dataFromDB = res["usersList"];
          if (!dataFromDB || !dataFromDB[0]) {
            this.setState({ showSearchNotFoundMsg: true, usersList: [] }, () => {
              this.setState({ reloadingTable: false });
            });
            return;
          }
          dataFromDB = dataFromDB.map((item) => {
            item.isEmailConfirmed = item.isEmailConfirmed ? 1 : 0;
            item.fullName = (item.firstName || "") + " " + (item.lastName || "");
            item.activityStatus = "";
            item.activeMembers = item.members ? item.members?.filter((x) => x.status === "active")?.length : 0;
            return item;
          });

          //adding the members to the data in the material table
          const usersAndMembersList = [...dataFromDB];
          dataFromDB.forEach((user) => {
            user?.members?.forEach((member) =>
              //get default columns for the material table
              usersAndMembersList.push({
                ...this.state.columns.reduce((acc, curr) => {
                  return { ...acc, [curr.field]: "" };
                }, {}),
                //add the specific member fields
                ...member,
                //activityStatus
                activityStatus: Object.values(activityStates).find((state) => state.field === member.status).title,
                //show cardNum
                cardNum: member.belongToCardNum
              })
            );
          });

          this.setState({ usersList: usersAndMembersList }, () => {
            this.setState({ reloadingTable: false });
          });
        }
      });
    });
  };
}

export default AdminUsersManager;
